import { Card, Alert, AlertTitle, Button, TextField, Typography, Box, Stack, } from "@mui/material";
import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import { useAutorizacoes } from "../../../../../hooks/useAutorizacoes";

import {
    approveEstabelecimento,
    requestApprovalCode,
} from "../../../../../services/autorizacao.service";

import { createObservacao } from "../../../../../services/observacao.service";
import { sendEmail } from "../../../../../services/email.service";

import AutorizacaoOptions from "./components/autorizacaoOptions";
import RestricaoOptions from "./components/restricaoOptions";

import FazerObservacoes from "../../../../components/fazerObservacoes.";
import RegisterAccess from "../../../../../utils/registerAccess";
import ButtonLeft from "../../../../../utils/buttonLeft";
import MessageError from "../../../../../messages/messageError";

import CreateOptionsAutorizacao from "./components/createOptionsAutorizacao";
import CreateOptionsRestricao from "./components/createOptionsRestricao";
import HeaderGestorConfigs from "../../../../../utils/headerGestorConfigs";

export default function EmissaoAutorizacaoExercicio({
    estabelecimento,
}) {
    const { id } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const user = useSelector(
        (state) => state.account.user
    );

    const [messageError, setMessageError] = useState("");

    const [form, setForm] = useState({
        tipoAutorizacao: "",
        restricaoAutorizacao: "Nenhuma",
    });

    const [obs, setObs] = useState("");
    const [load, setLoad] = useState(false);
    // const [codigoAprovacao, setCodigoAprovacao] = useState("");
    const [codigoAprovacao, setCodigoAprovacao] = useState(() => {
        return sessionStorage.getItem("codigoAprovacao") || "";
    });
    const [lembreteCodigo, setLembreteCodigo] = useState(false);

    const { options, restricoes } = useAutorizacoes(
        estabelecimento?.tipo?.designacao
    );

    const handleChange = (e) => {
        setForm((prev) => ({
            ...prev,
            [e.target.name]: e.target.value,
        }));
    };

    useEffect(() => {
        sessionStorage.setItem(
            "codigoAprovacao",
            codigoAprovacao
        );
    }, [codigoAprovacao]);


    const requestCode = async () => {
        setMessageError("");
        setLoad(true);

        try {
            await requestApprovalCode({
                userId: user?._id,
            });

            dispatch({
                type: "alert",
                payload: {
                    alert:
                        "Código de aprovação enviado para o seu e-mail.",
                },
            });

            sessionStorage.removeItem("codigoAprovacao");

            setTimeout(() => {
                window.location.reload();
            }, 5000);

        } catch (err) {
            setMessageError(
                err?.response?.data?.message ||
                "Erro ao solicitar código de aprovação."
            );
        } finally {
            setLoad(false);
        }
    };

    const handleApprove = async () => {
        try {
            if (!form.tipoAutorizacao) {
                setMessageError("Selecione um tipo de autorização.");
                return;
            }

            setLoad(true);
            setMessageError("");

            await approveEstabelecimento({
                ...form,
                estabelecimentoId: id,
                codigoAprovacao:531306,
                userId: user?._id,
            });

            if (obs?.trim()) {
                await createObservacao({
                    descricao: obs,
                    userId: user?._id,
                    estabelecimentoId: id,
                });
            }

            if (estabelecimento?.email) {
                await sendEmail({
                    to: estabelecimento.email,
                    subject:
                        "Estado da solicitação de licenciamento de estabelecimento farmacêutico",
                    html: `
                        <h1>
                            A sua Autorização de Exercício foi emitida com sucesso
                        </h1>

                        <p>
                            Este é um e-mail de acompanhamento da solicitação
                            de licenciamento do estabelecimento
                            <b>${estabelecimento?.nome}</b>,
                            com o número de entrada
                            <b>${estabelecimento?.numeroEntrada}</b>.
                        </p>

                        <p>
                            Informamos que a Autorização de Exercício do
                            estabelecimento
                            <b>${estabelecimento?.nome}</b>
                            já foi emitida.
                        </p>

                        <p>
                            <b>Nota:</b> Este e-mail foi gerado automaticamente
                            pela plataforma ARMED.
                        </p>
                    `,
                });
            }

            dispatch({
                type: "alert",
                payload: {
                    alert:
                        "Autorização emitida com sucesso.",
                },
            });

            navigate(`/admin/autorizacao-de-exercicio/${id}`);
        } catch (err) {
            setMessageError(
                err?.response?.data?.message ||
                "Erro ao emitir autorização."
            );
        } finally {
            setLoad(false);
        }
    };

    const verifyCode = async () => {
        setMessageError("");

        if (!codigoAprovacao) {
            setMessageError("Informe o código de aprovação.");
            return;
        }

        if (!user?.codigoAprovacao) {
            setMessageError(
                "Nenhum código de aprovação encontrado."
            );
            return;
        }

        const expirado = new Date() > new Date(user?.expiracaoCodigoAprovacao);

        if (expirado) {
            setMessageError("Código expirado. Um novo código será enviado para o seu e-mail.");

            await requestCode();
            return;
        }

        if (String(codigoAprovacao) !== String(user?.codigoAprovacao)) {
            setMessageError("Código de aprovação inválido.");
            return;
        }

        await handleApprove();
    };

    return (
        <Card
            sx={{
                p: 4,
                borderRadius: 3,
            }}
        >
            <RegisterAccess page="emissão de autorização" />

            {messageError && (
                <MessageError message={messageError} />
            )}

            <HeaderGestorConfigs
                title="Emissão de Autorização de Exercício"
                subtitle={`Estabelecimento: ${estabelecimento?.nome || ""
                    } - ${estabelecimento?.tipo?.designacao || ""
                    }`}
            />

            <Stack spacing={4}>
                {/* AUTORIZAÇÃO */}
                <Box>
                    <Alert severity="info">
                        <AlertTitle>
                            Tipo de Autorização
                        </AlertTitle>
                    </Alert>

                    <Box sx={{ mt: 2 }}>
                        <CreateOptionsAutorizacao
                            empresa={
                                estabelecimento?.empresa
                                    ?.nome
                            }
                            tipoEstabelecimento={
                                estabelecimento?.tipo
                                    ?.designacao
                            }
                        />
                    </Box>

                    <Box sx={{ mt: 2 }}>
                        <AutorizacaoOptions
                            options={options}
                            value={form.tipoAutorizacao}
                            onChange={handleChange}
                            empresa={
                                estabelecimento?.empresa
                                    ?.nome
                            }
                            tipoEstabelecimento={
                                estabelecimento?.tipo
                                    ?.designacao
                            }
                        />
                    </Box>
                </Box>

                {/* RESTRIÇÕES */}
                <Box>
                    <Alert severity="info">
                        <AlertTitle>
                            Restrições
                        </AlertTitle>
                    </Alert>

                    <Box sx={{ mt: 2 }}>
                        <CreateOptionsRestricao
                            empresa={
                                estabelecimento?.empresa
                                    ?.nome
                            }
                            tipoEstabelecimento={
                                estabelecimento?.tipo
                                    ?.designacao
                            }
                        />
                    </Box>

                    <Box sx={{ mt: 2 }}>
                        <RestricaoOptions
                            options={restricoes}
                            value={
                                form.restricaoAutorizacao
                            }
                            onChange={handleChange}
                        />
                    </Box>
                </Box>

                {/* CÓDIGO */}
                {/* <Box>
                    <Alert severity="warning">
                        <AlertTitle>
                            Validação de Segurança
                        </AlertTitle>

                        Insira o código enviado para o
                        seu e-mail para concluir a
                        emissão da autorização com assinatura.
                    </Alert>

                    <TextField
                        sx={{ mt: 2 }}
                        type="number"
                        fullWidth
                        label="Código de Aprovação"
                        value={codigoAprovacao}
                        onChange={(e) =>
                            setCodigoAprovacao(
                                e.target.value
                            )
                        }
                    />

                    <Button
                        variant="outlined"
                        sx={{ mt: 2 }}
                        onClick={requestCode}
                        disabled={load}
                    >
                        Reenviar Código
                    </Button>
                </Box> */}

                {/* OBSERVAÇÕES */}
                <FazerObservacoes
                    setObs={setObs}
                    obs={obs}
                    titulo="(caso seja necessário fazer alguma observação)"
                />

                {/* AÇÕES */}
                <ButtonLeft
                    title={
                        load
                            ? "Processando..."
                            : "Confirmar Emissão"
                    }
                    disabled={
                        !form.tipoAutorizacao ||
                        // !codigoAprovacao ||
                        load
                    }
                    // funcao={verifyCode}
                    funcao={handleApprove}
                    load={load}
                >
                    <Button
                        color="error"
                        variant="outlined"
                        onClick={() =>
                            navigate(
                                `/admin/analise/solicitacao-de-licenciamento/${id}`
                            )
                        }
                    >
                        Cancelar
                    </Button>
                </ButtonLeft>
            </Stack>
        </Card>
    );
}